import { render } from "./LocatorFiltersBrands.vue?vue&type=template&id=8522bd72"
import script from "./LocatorFiltersBrands.vue?vue&type=script&lang=js"
export * from "./LocatorFiltersBrands.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__